import { EVENTS, subscribe } from 'util.pubsub';

class ProductPrice extends HTMLElement {
  constructor() {
    super();
    this.setupEventListeners();
  }

  setupEventListeners() {
    if (this.type === 'subscription') {
      subscribe(EVENTS.planChange, this.handlePlanChange.bind(this));
      subscribe(EVENTS.cadenceChange, this.handleCadenceChange.bind(this));
    } else {
      subscribe(EVENTS.variantChange, this.handleVariantChange.bind(this));
    }
  }

  handleVariantChange(event) {
    console.log('variantChange', event);
  }

  handlePlanChange(event) {
    console.log('planChange', event);
  }

  handleCadenceChange(event) {
    console.log('cadenceChange', event);
  }

  get type() {
    return this.getAttribute('type');
  }
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}
